import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaGraduationCap, FaCheckCircle, FaChartLine, FaBell } from 'react-icons/fa';
import '../../../../assets/css/general/footer/FeaturesDetail.css';

const StudentPortal = () => {
  return (
    <div className="feature-detail-page">
      <div className="feature-detail-container">
        <Link to="/" className="back-button">
          <FaArrowLeft /> Back to Home
        </Link>

        <div className="feature-header">
          <div className="feature-icon-large">
            <FaGraduationCap />
          </div>
          <h1 className="feature-title">Student Portal</h1>
          <p className="feature-subtitle">
            Your personalized dashboard for managing support requests and tracking progress
          </p>
        </div>

        <div className="feature-content">
          <section className="feature-section">
            <h2>Welcome to Your Portal</h2>
            <p>
              The Student Portal is your central hub for managing all aspects of your 
              educational support journey. From submitting requests to tracking donations, 
              everything you need is at your fingertips.
            </p>
          </section>

          <section className="feature-section">
            <h2>Portal Features</h2>
            <div className="steps-grid">
              <div className="step-card">
                <div className="step-number">📝</div>
                <h3>Request Management</h3>
                <p>Create, edit, and track your support requests in one place.</p>
              </div>
              <div className="step-card">
                <div className="step-number">💰</div>
                <h3>Donation Tracking</h3>
                <p>See real-time updates on donations received for your requests.</p>
              </div>
              <div className="step-card">
                <div className="step-number">📊</div>
                <h3>Progress Reports</h3>
                <p>Share updates with donors about your academic achievements.</p>
              </div>
              <div className="step-card">
                <div className="step-number">💬</div>
                <h3>Donor Communication</h3>
                <p>Connect with your supporters through secure messaging.</p>
              </div>
            </div>
          </section>

          <section className="feature-section">
            <h2>Key Benefits</h2>
            <div className="features-list">
              <div className="feature-item">
                <FaCheckCircle className="feature-check" />
                <div>
                  <h4>Easy Access</h4>
                  <p>Access your portal anytime, anywhere from any device</p>
                </div>
              </div>
              <div className="feature-item">
                <FaChartLine className="feature-check" />
                <div>
                  <h4>Track Progress</h4>
                  <p>Monitor your funding goals and see how close you are to achieving them</p>
                </div>
              </div>
              <div className="feature-item">
                <FaBell className="feature-check" />
                <div>
                  <h4>Real-time Notifications</h4>
                  <p>Get instant alerts when someone donates or messages you</p>
                </div>
              </div>
              <div className="feature-item">
                <FaCheckCircle className="feature-check" />
                <div>
                  <h4>Document Management</h4>
                  <p>Securely store and update your academic and financial documents</p>
                </div>
              </div>
            </div>
          </section>

          <section className="feature-section cta-section">
            <h2>Ready to Access Your Portal?</h2>
            <p>Login or register to start managing your educational support journey today.</p>
            <button className="cta-button">Access Portal</button>
          </section>
        </div>
      </div>
    </div>
  );
};

export default StudentPortal;